import { inject } from '@angular/core';
import { CanActivateFn, CanDeactivateFn } from '@angular/router';
import { ObservableBoolean } from '@studiohyperdrive/rxjs-utils';
import { map } from 'rxjs/operators';

import { PreventNavigationGuard, StatusService } from '@vlaio/shared/core';

import { MaintenancePageComponent } from '../pages';

/**
 * Allows navigation in case the maintenance mode is active. If not, it redirects to the home page.
 */
export const ActivateMaintenanceGuard: CanActivateFn = (): ObservableBoolean => {
	// Iben: Fetch all injectables
	const statusService: StatusService = inject(StatusService);

	return PreventNavigationGuard(statusService.status$.pipe(map((isAvailable) => !isAvailable)));
};

/**
 * Is activated when the user tries to leave the maintenance page. It will only allow the user to leave if the
 * maintenance mode is not active anymore.
 *
 * @returns Whether the application is active.
 */
export const DeactivateMaintenanceGuard: CanDeactivateFn<MaintenancePageComponent> = (): ObservableBoolean => {
	const statusService: StatusService = inject(StatusService);

	return statusService.status$;
};
